import React from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import {
  Div, P, H4, H5, ButtoWhiteHoverGreen,
} from 'konsys-ui'
import Container from '../../components/container'
import PATH from '../../constants/path'
import { theme } from '../../styles/_variables'
import {
  BgContainer, WidthContainer, ChoiceWrapper, ChoiceContainer, TitleWrapper, Title, EachChoiceBox,
  EachChoiceContainer, EachChoiceBoxContentWrapper, Img, ContentTitleWrapper,
  SubContentWrapper, ContentWrapper, ImgDiv, SubText, SampleDiv, SampleImg,
} from './styled'
import Banner from '../../images/printing-information/banner.jpg'
import Background from '../../images/printing-information/background.jpg'
import Cupbox from '../../images/printing-information/Cup_Box.png'
import Plainbox from '../../images/printing-information/Plain_Box.png'

const ChoiceBox = props => (
  <Link to={props.path}>
    <EachChoiceBox>
      <ImgDiv>
        <Img src={props.img}/>
      </ImgDiv>
      <H4>{props.title}</H4>
      <EachChoiceBoxContentWrapper>
        <P>{props.content}</P>
      </EachChoiceBoxContentWrapper>
      <ButtoWhiteHoverGreen
        small
        text='อ่านเพิ่มเติม..'
        ghost
        color={theme.color.primaryColor}
        margin='32px 0 0'
      />
    </EachChoiceBox>
  </Link>
)

export const ContentInfo = props => (
  <ContentWrapper>
    <ContentTitleWrapper>
      <Title superGreen={props.superGreen}>{props.title}</Title>
    </ContentTitleWrapper>
    <P color={theme.color.lightGrey}>{props.content}</P>
    {
      props.extra
      && <Div margin='16px 0 0'>
        {_.map(props.extra, v => (
          <div key={v.content}>
            <SubText bold={v.bold}>{v.title}</SubText>
            <SubText light={v.light} addSpace={true}>{v.content}</SubText>
          </div>
        ))}
      </Div>
    }
    {
      props.subContent
      && <SubContentWrapper>
        {_.map(props.subContent, v => (
          <Div margin='0 0 16px' key={v.content}>
            <ContentTitleWrapper>
              <Title>{v.title}</Title>
            </ContentTitleWrapper>
            <P color={theme.color.lightGrey}>{v.content}</P>
            {
              v.extra
              && <Div margin='16px 0 0'>
                {_.map(v.extra, w => (
                  <div key={w.content}>
                    <SubText color={theme.color.lightGrey} bold={w.bold}>{w.title}</SubText>
                    <SubText light={w.light} addSpace={true}>{w.content}</SubText>
                  </div>
                ))}
              </Div>
            }
            {
              v.sample
              && <SampleDiv>
                {_.map(v.sample, u => (
                  <SampleImg key={u.src} onClick={() => props.openLightBox(u.image)} src={u.src}/>
                ))}
              </SampleDiv>
            }
          </Div>
        ))}
      </SubContentWrapper>
    }
    {
      props.sample
      && <SampleDiv>
        {_.map(props.sample, u => (
          <SampleImg key={u.src} onClick={() => props.openLightBox(u.image)} src={u.src}/>
        ))}
      </SampleDiv>
    }
  </ContentWrapper>
)

const PrintingInformation = () => (
  <Container
    header={{
      type: 'title',
      img: Banner,
      title: 'ข้อมูลกระดาษ และเทคนิคงานพิมพ์',
    }}
  >
    <Div>
      <BgContainer>
        <WidthContainer>
          <H5 color={theme.color.lightGrey}>สามารถศึกษาข้อมูลกระดาษและเทคนิคงานพิมพ์ เพื่อนำไปใช้ในการออกแบบกล่องบรรจุภัณฑ์ของคุณได้</H5>
        </WidthContainer>
        <ChoiceContainer>
          <TitleWrapper>
            <Title>กรุณาเลือกหัวข้อที่ต้องการศึกษา</Title>
          </TitleWrapper>
          <ChoiceWrapper bgImg={Background}>
            <EachChoiceContainer>
              <ChoiceBox
                img={Plainbox}
                title='ข้อมูลกระดาษ'
                content='กระดาษที่ใช้สำหรับบรรจุภัณฑ์มีหลากหลายประเภท สามารถเลือกใช้ตามความเหมาะสมกับการใช้งานของบรรจุภัณฑ์'
                path={PATH.paper}
              />
              <ChoiceBox
                img={Cupbox}
                title='ข้อมูลเทคนิคงานพิมพ์'
                content='กระบวนการพิมพ์พิเศษเพื่อเพิ่มความโดดเด่นของชิ้นงาน ได้แก่ การปั๊ม การเคลือบ การเจาะ และการปะ'
                path={PATH.printingTechnique}
              />
            </EachChoiceContainer>
          </ChoiceWrapper>
        </ChoiceContainer>
      </BgContainer>
    </Div>
  </Container>
)

export default PrintingInformation



// WEBPACK FOOTER //
// ./src/pages/printing-information/index.jsx